import { getTranslate } from 'assets/titles/title-text';

import { ReactComponent as TextBlockIcon } from 'assets/icons/constructor-create-icons/TEXT_BLOCK.svg';
import { ReactComponent as DomainIcon } from 'assets/icons/constructor-icons/DOMAIN.svg';
import { ReactComponent as DocumentAuthor } from 'assets/icons/constructor-icons/AUTHOR.svg';
import { ReactComponent as UrlIcon } from 'assets/icons/constructor-icons/URL.svg';
import { ReactComponent as DocumentTypeIcon } from 'assets/icons/constructor-icons/DOCUMENT_TYPE.svg';
import { ReactComponent as LocationIcon } from 'assets/icons/constructor-icons/LOCATION.svg';
import { ReactComponent as DocumentDateIcon } from 'assets/icons/constructor-icons/DOCUMENT_DATE.svg';
import { ReactComponent as SentimentIcon } from 'assets/icons/constructor-icons/SENTIMENT.svg';
import { ReactComponent as DocumentCoverageIcon } from 'assets/icons/constructor-icons/DOCUMENT_COVERAGE.svg';
import { ReactComponent as DocumentContentIcon } from 'assets/icons/constructor-icons/DOCUMENT_CONTENT.svg';
import { ReactComponent as DocumentNumbersIcon } from 'assets/icons/constructor-icons/DOCUMENT_NUMBERS.svg';
import { ReactComponent as DocumentTagsIcon } from 'assets/icons/constructor-icons/DOCUMENT_TAGS.svg';
import { ReactComponent as FeedIcon } from 'assets/icons/constructor-create-icons/FEED.svg';

export const getIconByName = (name) => {
    switch(name){
        case 'DOCUMENT_TITLE':
            return <FeedIcon />; 

        case 'DOCUMENT_DOMAIN':
            return <DomainIcon />;
        case 'DOCUMENT_AUTHOR':
            return <DocumentAuthor />
        case 'DOCUMENT_URL':
            return <UrlIcon />;

        case 'DOCUMENT_TYPE':
            return <DocumentTypeIcon />;

        case 'DOCUMENT_SENTIMENT':
            return <SentimentIcon />;
        case 'DOCUMENT_LOCATION':
            return <LocationIcon />;
        case 'DOCUMENT_DATE':
            return <DocumentDateIcon />;
        case 'DOCUMENT_COVERAGE':
            return <DocumentCoverageIcon />;
        case 'DOCUMENT_TEXT':
            return <DocumentContentIcon />;
        case 'DOCUMENT_TAGS':
            return < DocumentTagsIcon />;
        case 'DOCUMENT_NUMERATION':
            return <DocumentNumbersIcon />;
        case 'TOPIC_NAME':
            return <TopicIcon />;
        case 'DATE_RANGE':
            return <PeriodIcon />;
        case 'DOCUMENT_NUMFOUND':
            return <DocumentNumfoundIcon />;

        default:
            return getTranslate(name);
    }
}

export const getName = (name) => {
    switch(name){
        case 'TEXT':
            return getTranslate('TEXT_BLOCK');
        default:
            return getTranslate(name);
    }
}